import * as React from 'react';
import { observer } from 'mobx-react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { Checkbox } from '../Checkbox';
import { ParamsFilterType } from '../../../../../models/hotel-reviews';
import { getVerbalHotelReviews } from '../../../../../utils/format';
import S from '../../../../../stores';

export interface ParamsFilterProps {
    reviewsAmount: {
        withPhoto: number;
        withDetailedText: number;
        withDetailedRatings: number;
    };
}

interface StyledParamsFilterProps extends JSSClassesProps<ComponentJSSClasses>, ParamsFilterProps {}

export const ParamsFilter = observer((props: StyledParamsFilterProps) => {
    const { withPhoto, withDetailedText, withDetailedRatings } = props.reviewsAmount;

    const isChecked = (param: ParamsFilterType): boolean =>
        S.hotelReviews.paramsFilter.includes(param);

    const handleChange = (param: ParamsFilterType) => {
        S.hotelReviews.setParamsFilter(param);
    };

    return (
        <div>
            <Checkbox
                inputName={'С фото'}
                label={ParamsFilterType.WithPhoto}
                checked={isChecked(ParamsFilterType.WithPhoto)}
                onChange={() => handleChange(ParamsFilterType.WithPhoto)}
                caption={`${withPhoto} ${getVerbalHotelReviews(withPhoto)}`}
            />
            <Checkbox
                inputName={'С подробным описанием'}
                label={ParamsFilterType.WithDetailedText}
                checked={isChecked(ParamsFilterType.WithDetailedText)}
                onChange={() => handleChange(ParamsFilterType.WithDetailedText)}
                caption={`${withDetailedText}  ${getVerbalHotelReviews(withDetailedText)}`}
            />
            <Checkbox
                inputName={'С детальной оценкой'}
                label={ParamsFilterType.WithDetailedRatings}
                checked={isChecked(ParamsFilterType.WithDetailedRatings)}
                onChange={() => handleChange(ParamsFilterType.WithDetailedRatings)}
                caption={`${withDetailedRatings} ${getVerbalHotelReviews(withDetailedRatings)}`}
            />
        </div>
    );
});
